<template>
  <div class="login-page d-flex align-items-center">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 login-shell">
          <!-- Header / Brand -->
          <div class="text-center ">
            <img src="@/assets/docbrain1.png" alt="DocBrain" class="brand-logo" />
            <!-- <h1 class="h4 mb-1 text-white fw-semibold">DocBrain</h1>
            <p class="text-white-50 mb-0">
              Inteligencia aplicada en tecnología
            </p> -->
          </div>

          <!-- Card -->
          <div class="card shadow-lg border-0 rounded-4 overflow-hidden">
            <div class="card-body p-4 p-md-4">
              <div class="d-flex align-items-start justify-content-between mb-3">
                <div>
                  <h2 class="h5 fw-bold mb-1">Ingresar</h2>
                  <p class="text-muted mb-0 small">
                    Accedé a tu panel de forma segura.
                  </p>
                </div>

                <div class="secure-badge d-flex align-items-center gap-2">
                  <span class="lock-dot" aria-hidden="true"></span>
                  <span class="small text-muted">Conexión segura</span>
                </div>
              </div>

              <form @submit.prevent="login" novalidate>
                <!-- Usuario -->
                <div class="mb-3">
                  <label for="usuario" class="form-label">Email</label>
                  <div class="input-group">
                    <span class="input-group-text bg-white">
                      <!-- icon user (inline svg, sin dependencias) -->
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M20 21a8 8 0 1 0-16 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </span>
                    <input
                      v-model.trim="usuario"
                      type="text"
                      class="form-control"
                      id="usuario"
                      autocomplete="username"
                      required
                      :disabled="loading"
                      placeholder="tu@email.com"
                    />
                  </div>
                </div>

                <!-- Contraseña -->
                <div class="mb-2">
                  <label for="contrasena" class="form-label">Contraseña</label>
                  <div class="input-group">
                    <span class="input-group-text bg-white">
                      <!-- icon lock -->
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M7 11V8a5 5 0 0 1 10 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 11h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </span>

                    <input
                      v-model="contrasena"
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control"
                      id="contrasena"
                      autocomplete="current-password"
                      required
                      :disabled="loading"
                      placeholder="••••••••"
                    />

                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="showPassword = !showPassword"
                      :disabled="loading"
                      :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                      title="Mostrar/Ocultar"
                    >
                      <span v-if="!showPassword">Mostrar</span>
                      <span v-else>Ocultar</span>
                    </button>
                  </div>
                </div>

                <!-- Help row -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="remember"
                      v-model="remember"
                      :disabled="loading"
                    />
                    <label class="form-check-label small" for="remember">
                      Recordarme
                    </label>
                  </div>

                  <a class="small text-decoration-none" href="#" @click.prevent="forgotPassword">
                    ¿Olvidaste tu contraseña?
                  </a>
                </div>

                <div v-if="success" class="alert alert-success py-2 small" role="alert">
                  {{ success }}
                </div>

                <!-- Error -->
                <div v-if="error" class="alert alert-danger py-2 small" role="alert">
                  {{ error }}
                </div>

                <div v-if="canResendVerification" class="mt-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="resendVerification"
                    :disabled="loading || resendingVerification || !usuario"
                  >
                    {{ resendingVerification ? 'Reenviando…' : 'Reenviar correo de activación' }}
                  </button>
                </div>

                <!-- Submit -->
                <button
                  type="submit"
                  class="btn btn-primary w-100 py-2 fw-semibold"
                  :disabled="loading || !usuario || !contrasena"
                >
                  <span v-if="loading" class="d-inline-flex align-items-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Verificando…
                  </span>
                  <span v-else>Ingresar</span>
                </button>

                <div class="position-relative my-3">
                  <hr class="my-0" />
                  <span class="auth-separator text-muted small">o</span>
                </div>

                <div
                  ref="googleButtonRef"
                  class="google-button-slot"
                  :class="{ 'is-disabled': loading }"
                ></div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                    <span class="text-muted small">¿No tenés cuenta?</span>
                    <button type="button" class="btn btn-sm" @click="router.push('/registrarse')">
                        Registrarse
                    </button>
                    </div>

                <!-- Footer note -->
                <div class="text-center mt-3">
                  <p class="text-muted small mb-0">
                    Al ingresar aceptás las políticas de seguridad de la plataforma.
                  </p>
                </div>
              </form>
            </div>

            <!-- Card footer (marca/seguridad) -->
            <div class="card-footer bg-light border-0 py-3 px-4">
              <div class="d-flex justify-content-between align-items-center">
                <span class="small text-muted">© {{ new Date().getFullYear() }} DocBrain</span>
                <span class="small text-muted d-flex align-items-center gap-2">
                  <span class="shield" aria-hidden="true"></span>
                  TLS / HTTPS
                </span>
              </div>
            </div>
          </div>

          <!-- Extra: mini nota -->
          <div class="text-center mt-4">
            <span class="text-white-50 small">
              ¿Necesitás acceso? Contactá al administrador.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api'
import { renderGoogleButton } from '@/services/googleIdentity'
import { getRecaptchaToken } from '@/services/recaptcha'

// 👇 Ajustá el logo a donde lo tengas.
// Recomendación: poner el logo en /src/assets/docbrain-logo.png

const router = useRouter()
const store = useStore()

const usuario = ref('')
const contrasena = ref('')
const success = ref('')
const error = ref('')
const loading = ref(false)
const resendingVerification = ref(false)
const remember = ref(true)
const showPassword = ref(false)
const canResendVerification = ref(false)
const googleButtonRef = ref<HTMLElement | null>(null)

const login = async () => {
  error.value = ''
  success.value = ''
  canResendVerification.value = false
  loading.value = true

  try {
    const recaptchaToken = await getRecaptchaToken('login')

    const res = await api.post('/auth/login', {
      email: usuario.value,
      password: contrasena.value,
      recaptcha_token: recaptchaToken
    })

    // Guardado simple (igual que tenías). Si querés token, lo acomodamos.
    store.commit('setAuth', {
      token: res.data.access_token,
      user: res.data.user
    })

    // Si querés “recordarme” real: guardar usuario (o token) con expiración, etc.
    if (remember.value) {
      localStorage.setItem('docbrain_user', usuario.value)
    } else {
      localStorage.removeItem('docbrain_user')
    }

    router.push('/dashboard')
  } catch (e: any) {
    error.value = e?.response?.data?.detail || e?.message || 'Usuario o contraseña incorrectos'
    canResendVerification.value = e?.response?.data?.detail === 'Cuenta no verificada. Revisá tu email.'
  } finally {
    loading.value = false
  }
}

const loginWithGoogle = async (credential: string) => {
  error.value = ''
  success.value = ''
  canResendVerification.value = false
  loading.value = true

  try {
    const res = await api.post('/auth/google', { credential })

    store.commit('setAuth', {
      token: res.data.access_token,
      user: res.data.user
    })

    localStorage.setItem('docbrain_user', res.data.user.email)
    router.push('/dashboard')
  } catch (e: any) {
    error.value = e?.response?.data?.detail || e?.message || 'No se pudo iniciar sesión con Google'
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  if (!googleButtonRef.value) return

  try {
    await renderGoogleButton(googleButtonRef.value, loginWithGoogle)
  } catch (e: any) {
    error.value = e?.message || 'No se pudo cargar Google Sign-In'
  }
})

const resendVerification = async () => {
  error.value = ''
  success.value = ''
  resendingVerification.value = true

  try {
    const res = await api.post('/auth/resend-verification', {
      email: usuario.value
    })
    success.value = res?.data?.message || 'Correo de activación reenviado.'
    canResendVerification.value = false
  } catch (e: any) {
    error.value = e?.response?.data?.detail || 'No se pudo reenviar el correo de activación.'
  } finally {
    resendingVerification.value = false
  }
}

const forgotPassword = () => {
  // Placeholder. Acá podés abrir modal, ir a /reset-password, etc.
  error.value = 'Función de recuperación pendiente de implementación.'
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  /* Fondo serio: degradé oscuro + un toque de luz */
  background:
    radial-gradient(1000px 500px at 20% 10%, rgba(0, 210, 255, 0.18), transparent 60%),
    radial-gradient(900px 500px at 80% 30%, rgba(0, 120, 255, 0.18), transparent 55%),
    linear-gradient(160deg, #061a2a 0%, #06203a 45%, #031526 100%);
}

.brand-logo {
  width: 640px;
  max-width: 180%;
  display: block;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -18px;
  margin-bottom: -118px;
  height: auto;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.25));
}

.login-shell {
  transform: translateY(-122px);
}

.secure-badge {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.04);
}

.lock-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.15);
}

.shield {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #0d6efd;
  display: inline-block;
}

.auth-separator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 0 12px;
}

.google-button-slot {
  min-height: 44px;
}

.google-button-slot.is-disabled {
  opacity: 0.65;
  pointer-events: none;
}

/* Toque de “producto serio”: inputs más altos */
.form-control, .input-group-text, .btn {
  border-radius: 12px;
}
.input-group > .form-control {
  border-left: 0;
}
.input-group-text {
  border-right: 0;
}
</style>
